import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mo-search-view"
}
const _hoisted_2 = { class: "mo-search-view__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_filter_general = _resolveComponent("search-filter-general")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {
          focus: () => $setup.focus()
        })
      ]),
      _: 3
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (!$setup.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "mo-search-view__overlay",
                onClick: $setup.unfocus
              }),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_search_filter_general, {
                  "current-city": $props.currentCity,
                  ref: "input"
                }, null, 8, ["current-city"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}